import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import useReveal from "../hooks/useReveal";
import { useLang } from "../i18n/LanguageContext";

export default function HowItWorks() {
  useReveal();
  const navigate = useNavigate();
  const { t, tList } = useLang();
  const steps = tList("steps");
  return (
    <section id="how" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl reveal">
          <span className="text-xs uppercase tracking-[0.2em] text-[#F5B400] font-semibold">{t("how_eyebrow")}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-black leading-tight">{t("how_title")}</h2>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="reveal relative rounded-2xl bg-white border border-slate-100 shadow-sm p-8" style={{ animationDelay: `${i * 0.1}s` }} data-testid={`step-${i}`}>
              <div className="w-12 h-12 rounded-full bg-[#F5B400] text-neutral-900 font-display font-bold text-lg flex items-center justify-center">{i + 1}</div>
              <h3 className="mt-5 font-display text-lg font-semibold text-black">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 reveal">
          <Button onClick={() => navigate("/booking")} className="bg-[#F5B400] hover:bg-[#D99A00] text-neutral-900 rounded-full px-8 h-12 font-semibold" data-testid="how-cta">
            {t("how_cta")} <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
}
